import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { DxDataGridComponent, DxDropDownBoxComponent } from 'devextreme-angular';
import { Observable, Subscription } from 'rxjs';
import { TypeAccesPersonneMoraleDto } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-types-acces-select',
  templateUrl: './types-acces-select.component.html',
  styleUrls: ['./types-acces-select.component.css']
})
export class TypesAccesSelectComponent implements OnInit {
  @Select(ControlPanelStore.typesAcces$) typesAcces$: Observable<TypeAccesPersonneMoraleDto[]>;

  @ViewChild('dxDropDown') dropDown: DxDropDownBoxComponent;
  @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

  @Input() disabled: boolean = false;
  @Input() width: number;
  @Input() widthPopUp: number = 250;

  @Input() typeAccesId: number;
  @Output() typeAccesIdChange = new EventEmitter<number>();

  @Input() cell: any;

  InitId = null;

  TypesAcces: TypeAccesPersonneMoraleDto[] = [];
  ColumnName = [];

  ta: Subscription;

  constructor(private panelLayoutService: PanelLayoutService,
    private translate: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
      // Instanciate Globalize for DevExtreme components
      this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());
      this.translate.get(
        [
          'Identifiant',
          'Reference'
        ]
        ).subscribe(translations => {
          this.ColumnName.push(translations['Identifiant']);
          this.ColumnName.push(translations['Reference']);
        });
    }

  ngOnInit() {
    if(this.typeAccesId != null) {
      this.InitId = JSON.parse(JSON.stringify(this.typeAccesId));
    }
    this.ta = this.typesAcces$.subscribe(res => {
      if (res != null) {
        this.TypesAcces = res;
      }
    });
  }

  ngOnDestroy() {
    this.ta?.unsubscribe();
  }

  updateInfo(event) {
    this.typeAccesId = event.currentSelectedRowKeys.length == 1 ? event.currentSelectedRowKeys[0].Id : this.typeAccesId;
    if (!!this.cell && this.InitId != this.typeAccesId) {
      this.cell.setValue(this.typeAccesId);
    }
    this.typeAccesIdChange.emit(this.typeAccesId);

    if(this.typeAccesId != null) {
      this.dropDown.instance.close();
    }
  }

  onOpened() {
    if(this.typeAccesId == null) {
      this.dataGrid.instance.clearSelection();
    }

    document.body.childNodes.forEach(element => {
      if(element.nodeType == 1) {
        if((element as HTMLElement).className.includes("dx-dropdowneditor-overlay")) {
          (element.childNodes[0] as HTMLElement).style.width = `${this.widthPopUp}px`;
        }
      }
    });
  }

}
